import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@mui/material';
import { useAnalyticsContext } from '../../contexts/AnalyticsContext';
/**
 * This Link will send analytics in case the analytics context is passed through
 * the provider (AnalyticsProvider).
 */
export var MUILinkWithTracking = function (_a) {
    var eventName = _a.eventName, eventProperties = _a.eventProperties, children = _a.children, onClick = _a.onClick, rest = __rest(_a, ["eventName", "eventProperties", "children", "onClick"]);
    var state = useAnalyticsContext().state;
    var handleClick = function (event) {
        if (!state.webTracker) {
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
            return;
        }
        if (eventName) {
            state.webTracker.track(eventName, eventProperties);
        }
        else {
            state.webTracker.trackNavigationClick("".concat(rest.href), eventProperties);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    return (_jsx(Link, __assign({}, rest, { onClick: handleClick, rel: rest.target === '_blank' ? 'noreferrer' : undefined }, { children: children })));
};
